var map = {
	"./aquaponics.jpeg": 352,
	"./aquaponics.jpg": 573,
	"./brown_guy.png": 888,
	"./dump.png": 759,
	"./football.jpg": 331,
	"./heist.png": 798,
	"./pong.png": 866,
	"./pong2.png": 159,
	"./pong3.png": 79,
	"./portfolio.jpg": 340,
	"./posture.png": 755,
	"./react_portfolio.jpeg": 375,
	"./shooter.png": 465,
	"./vanilla_portfolio.jpeg": 738
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 303;